<div class="bg"></div>
<div style="display: flex; flex-direction: column; flex-wrap: wrap; justify-items: start; align-items: center">
  <h1 class="title" style="margin-top: 4vh">Albion Online Market Tools</h1>
  <h2 class="text">Market Prices, Crafting Calculator, Farming Calculator, Black Market Flipper and Much More</h2>
  <h3 class="text small">Join thousands of players making smarter trades and higher profits</h3>

  <!-- MARK: Buttons -->
  <div class="line-group buttons">
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openSupportLink()" style="width: 100%">
        <div style="display: flex; align-items: center">
          <div style="height: 30px; margin-right: 10px; align-content: center">
            <mat-icon color="warn">favorite</mat-icon>
          </div>
          Subscribe to AFM
        </div>
      </button>
    </div>
  </div>
  <div class="line-group buttons">
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="authService.googleSignIn()" style="width: 100%" [disabled]="authService.user$ | async">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/google.svg" style="margin-right: 10px" alt="Google Icon" height="20" width="20" />
          {{ (authService.user$ | async) ? "You're logged in" : 'Sign Up with Google' }}
        </div>
      </button>
    </div>
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openLink('https://www.youtube.com/@AlbionFreeMarket')" style="width: 100%">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/youtubeicon.webp" style="margin-right: 10px" alt="Youtube Icon" height="30" width="30" />
          YouTube Tutorials
        </div>
      </button>
    </div>
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openLink('https://discord.com/invite/BPmDE3zznH')" style="width: 100%">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/discordicon.webp" style="margin-right: 10px" alt="Discord Icon" height="30" width="30" />
          Join our Discord
        </div>
      </button>
    </div>
  </div>

  <!-- MARK: Numbers -->
  <div class="number-group">
    <div class="number-container">
      <div class="number">{{ afmStats()?.usersCount ? (afmStats()?.usersCount | smallNumber) : '00.0k' }}</div>
      <div class="number-text">Registered Users</div>
    </div>
    <div class="number-container">
      <div class="number">{{ afmStats()?.flipsProfit ? (afmStats()?.flipsProfit | smallNumber) : '00.0B' }}</div>
      <div class="number-text">Flipper Profit</div>
    </div>
    <div class="number-container">
      <div class="number">{{ afmStats()?.totalIncome ? ((afmStats()?.totalIncome ?? 0) - (afmStats()?.totalCost ?? 0) | smallNumber) : '0.0B' }}</div>
      <div class="number-text">Craft Profit</div>
    </div>
  </div>

  <!-- MARK: Verified Lines -->
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Available on all 3 servers</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Access <a href="https://www.albion-online-data.com/" target="_blank">AODP</a> market prices</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Custom <a href="https://github.com/JPCodeCraft/AlbionDataAvalonia" target="_blank">Data Client</a> with friendly UI</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">The best Albion Market Tools anywhere</span>
  </div>

  <!-- MARK: Testimonials -->
  <h2 class="title" style="margin-top: 50px">What Our Users Say</h2>
  <div class="testimonials">
    @for (testimonial of testimonials; track testimonial.name) {
      <mat-card class="testimonial-card">
        <mat-card-header>
          <img mat-card-avatar [ngSrc]="testimonial.image" alt="User avatar" width="40" height="40" />
          <mat-card-title>{{ testimonial.name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="rating-stars">
            @for (star of [0, 1, 2, 3, 4]; track star) {
              <mat-icon>{{ getStar(testimonial.rating, star) }}</mat-icon>
            }
          </div>
          <p>{{ testimonial.text }}</p>
        </mat-card-content>
      </mat-card>
    }
  </div>

  <!-- MARK: Content Creators -->
  <!-- <app-content-creators style="margin: 50px 0px"></app-content-creators> -->

  <!-- <h2 class="title" style="margin-bottom: 40px">Video Spotlight</h2>

  @if (videoUrl) {
    <iframe
      width="560"
      height="315"
      class="highlight"
      [src]="videoUrl()"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  } -->
  <!-- MARK: Price Check -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/pricecheck">Real-time Albion Market Prices</a></h2>
  <h3 class="text">Check Market Prices Instantly</h3>
  <p class="text details">Instantly check Albion market prices for any item! Get live data from the Albion Online Data Project, search for one or many items, and save your favorites for quick access. Never miss a good deal again.</p>
  <app-gallery [images]="priceCheckImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Flipper-->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/flipper">Black Market Flipper</a></h2>
  <h3 class="text">Instant Flips, Instant Profit</h3>
  <p class="text details">
    Discover the fastest way to make silver in Albion! Instantly find the best market flips—buy in Caerleon, sell at the Black Market, or take a risk and transport for even bigger profits. Our real-time data helps you spot safe, high-value
    trades in seconds.
  </p>
  <app-gallery [images]="flipperImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Craft -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/crafting">Crafting & Refining Calculator</a></h2>
  <h3 class="text">Craft, Refine, and Profit</h3>
  <p class="text details">
    Take your crafting to the next level! Instantly calculate profits for crafting, refining, or transmuting any item. Our tool loads prices automatically, factors in resource returns, focus, and food, and helps you find the most profitable
    crafts. Save your crafts and track your history with ease.
  </p>
  <app-gallery [images]="craftImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Map -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/albion-map">Albion Online Map</a></h2>
  <h3 class="text">Interactive Map & Route Finder</h3>
  <p class="text details">
    Plan your journey with our interactive Albion map! See PvP zones, territory types, and connections at a glance. Use smart pathfinding to find the safest or fastest routes—just set your start and end points and get a detailed travel
    summary.
  </p>
  <app-gallery [images]="mapImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Top Trade Items -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/topitems">Top Traded Items</a></h2>
  <h3 class="text">See What Everyone's Trading</h3>
  <p class="text details">Curious about the hottest items in Albion? Our servers crunch all the market data to show you the most traded items every day. Pick a date range, see daily averages, and get a real sense of what’s moving.</p>
  <app-gallery [images]="topItemsImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Trade Flipper -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/transport">Trade Calculator</a></h2>
  <h3 class="text">Profitable Trade Routes</h3>
  <p class="text details">
    Want to make silver by buying and selling goods? Instantly find the most profitable trade routes between cities and markets. Filter by item, set your weight and capacity, and let our tool do the math—perfect for solo traders and guild
    logistics alike.
  </p>
  <app-gallery [images]="tradeCalculatorImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Farm Calculator -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/farming">Farm & Breed Calculator</a></h2>
  <h3 class="text">Optimize Your Farming and Breeding</h3>
  <p class="text details">
    Take the guesswork out of farming! Calculate profits, resources, and time for all your crops and animals. Compare island and territory farming, set your own market locations, and see real profit estimates based on live prices. Save your
    favorite setups and maximize your yields every day.
  </p>
  <app-gallery [images]="farmCalculatorImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Trade Routes -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/traderoutes">Trade Routes Finder</a></h2>
  <h3 class="text">Find the Best Trade Routes</h3>
  <p class="text details">Want to buy low and sell high? Our Trade Routes Finder analyzes the last 7 days of market data to show you the most profitable routes in Albion. Let us do the number crunching so you can focus on making silver!</p>
  <app-gallery [images]="tradeRoutesImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>

  <!-- MARK: Meta -->
  <h2 class="title" style="margin-top: 50px"><a routerLink="/metaitems">Meta Items & PvP Tracker</a></h2>
  <h3 class="text">Find the Best Gear for PvP</h3>
  <p class="text details">
    Discover the most popular and effective gear sets in Albion! Filter and sort by any stat, including KDR, to find your perfect build. Access our real-time PvP tracker, check server peak hours, and learn what it takes to win more fights.
  </p>
  <app-gallery [images]="metaImages" [maxWidth]="'1100px'" [maxThumbs]="3"></app-gallery>
</div>
